import LdHowItWorks from 'lion-vue-src/Shared/components/LdHowItWorks';
export default LdHowItWorks;
